import React, { Component } from 'react';
import { FormicaProps, withFormica } from '../../helpers/withFormica';
import Icon from '../../icons/Icon';
import CustomAnimateButton from '../../components/custom/CustomAnimateButton';
import LanguageUtil from '../../util/LanguageUtil';

class NotFound extends Component<Props, State> {
  public state = new State();

  render() {
    return (
      <div className={'flex flex-col w-full h-screen items-center justify-center bg-[#F9FAFB] rounded-md'}>
        <img src={'/errors/not-found.svg'} alt='security' className={'w-[500px]'} />
        <p className={'text-[24px] text-[#4F4F4F] mt-[-40px]'}>{LanguageUtil.get({ id: 'components.notFound.notFound', defaultMessage: 'Page Not Found' })}</p>
        <p className={'text-[16px] text-[#4F4F4F] mt-[8px]'}>
          {LanguageUtil.get({ id: 'components.notFound.cantFind', defaultMessage: "Sorry, we can't find the page you're looking for." })}
        </p>
        <CustomAnimateButton
          customSize={'md'}
          className={'mt-[16px] w-[200px]'}
          icon={<Icon icon={'arrow-right'} size={40} />}
          text={LanguageUtil.get({ id: 'common.button.goHome', defaultMessage: 'Go to Home Page' })}
          onClick={() => this.props.router.navigate('/')}
        />
      </div>
    );
  }

  public componentDidMount() {
    const timerInterval = setInterval(() => {
      this.setState({ timer: this.state.timer - 1 }, () => {
        if (this.state.timer == 0) {
          this.props.router.navigate('/');
        }
      });
    }, 1000);
    this.setState({ timerInterval });
  }

  public componentWillUnmount() {
    clearInterval(this.state.timerInterval);
  }
}

class State {
  timer: number = 5;
  timerInterval: any = null;
}

interface Props extends FormicaProps {}

export default withFormica(NotFound);
